<template>
  <header
      class="header">
    <div class="top">
      <div class="back-area"
           @click="emit('changePage', 'package')"
      ></div>
    </div>

    <div class="opera">
      <el-icon
          v-if="showBack"
          size="20" style="cursor:pointer;" @click="emit('back')">
        <Back/>
      </el-icon>

      <h5
          :style="mainTitleStyle"
          @click="emit('home')">{{ mainTitle }}</h5>

      <div v-for="(item,idx) in currentTitle"
           :key="idx" class="item"
           :class="{'last': idx == currentTitle.length - 1}"
      >
        {{ item }}
        <span
            v-if="idx != currentTitle.length - 1"
            style="margin-right: 10px;color: #999999;">></span>
      </div>

    </div>
  </header>
</template>

<script setup>
const props = defineProps({
  currentTitle: {
    type: Array,
    default: () => []
  },
  mainTitle: {
    type: String,
    default: ''
  },
  showBack: {
    type: Boolean,
    default: true
  },
  mainTitleStyle: {
    type: Object,
    default: undefined
  }
});

const emit = defineEmits(['back', 'home', 'changePage']);
</script>


<style scoped lang="scss">
.header {
  .top {
    height: 56px;
    background-image: url(https://static.rhkj.com/renhe_fe/other/316.png);
    background-size: cover;

    .back-area {
      height: 100%;
      width: 380px;
      cursor: pointer;
    }
  }

  .opera {
    color: #333333;
    font-size: 14px;
    display: flex;
    align-items: center;
    height: 60px;
    padding-left: 20px;

    > h5 {
      font-size: 20px;
      color: #333;
      font-weight: 700;
      margin-right: 20px;
      margin-left: 10px;
      cursor: pointer;
    }

    .item {
      color: #888888;

      &.last {
        color: #111111;
      }
    }
  }
}
</style>
